import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

interface CertData {
  has_cert: boolean;
  cert_number: string;
  id_card: string;
  name: string;
  issuing_authority: string;
  issue_date: string;
  area: string;
  residents: string;
  cert_image?: string;
}

export default function SettlementCert() {
  const navigate = useNavigate();
  const [data, setData] = useState<CertData | null>(null);
  const [loading, setLoading] = useState(true);
  const [showCert, setShowCert] = useState(false);

  useEffect(() => {
    api.get('/property-certificate/settlement-cert').then(({ data }) => {
      setData(data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="max-w-md mx-auto min-h-screen flex items-center justify-center" style={{ backgroundColor: '#c22a1e' }}>
        <div className="w-8 h-8 border-3 border-white/30 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto min-h-screen pb-6 relative" style={{ backgroundColor: '#c22a1e' }}>
      <AuthGuard />
      <button
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-black/20 text-white"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
      </button>

      {/* Header */}
      <div className="relative">
        <img src="/images/wanjie_fbrijing.png" alt="" className="w-full" />
    
        {/* Main content card */}
        <div className="px-3 absolute top-[210px] left-0 right-0 z-10">
          <div className="rounded-2xl overflow-hidden px-4 pt-2">

            {/* Certificate info row */}
            <div className="flex gap-3 bg-white rounded-lg p-3 relative">
              <div className="w-[120px] flex-shrink-0 rounded-lg border border-gray-100">
                <img src="/images/jindu_tu.png" alt="户型图" className="w-full" />
              </div>

              <div className="flex-1 space-y-2 text-xs pt-0.5">
                <div className="flex items-baseline">
                  <span className="text-[#999] w-[65px] flex-shrink-0">证书编号</span>
                  <span className="text-[#333] font-bold">{data?.cert_number || '---'}</span>
                </div>
                <div className="flex items-baseline">
                  <span className="text-[#999] w-[65px] flex-shrink-0">特困档案号</span>
                  <span className="text-[#333] text-[11px]">{data?.id_card || '---'}</span>
                </div>
                <div className="flex items-baseline">
                  <span className="text-[#999] w-[65px] flex-shrink-0">发证单位</span>
                  <span className="text-[#333]">{data?.issuing_authority || '---'}</span>
                </div>
                <div className="flex items-baseline">
                  <span className="text-[#999] w-[65px] flex-shrink-0">发放日期</span>
                  <span className="text-[#333]">{data?.issue_date || '---'}</span>
                </div>
              </div>

              <div className="flex-shrink-0 absolute top-[20px] right-[10px]">
                <img src="/images/wanjie_zhang.png" alt="" className="w-[70px] h-[70px]" />
              </div>
            </div>

            {/* Description text */}
            <div className="pt-2">
              <div className="flex items-start gap-2">
                <div className="w-1 min-h-[16px] bg-[#c4161c] rounded-full flex-shrink-0 mt-1" />
                <div className="text-[12px] text-[#333] leading-[1.8]">
                  兹证明 <span className="text-[#c4161c] font-bold">{data?.name || '---'}</span>，已通过【
                  <span className="inline-block w-[100px]" />获得特困人员资格
                  （使用特困入住人员政策申办，安居一键通）】，完成各下坐落于
                </div>
              </div> 
            </div>
 
          </div>
        </div>
        {/* View Certificate Button */}
        <div className="px-3 absolute bottom-[25px] left-0 right-0 z-10">
          <button
            onClick={() => data?.cert_image && setShowCert(true)} 
          >
            <img src="/images/wanjie_chakan.png" alt="" className="w-full" />
          </button>
        </div>
      </div>


      {/* Certificate Modal */}
      {showCert && data?.cert_image && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={() => setShowCert(false)}>
          <div className="relative max-w-[95vw] max-h-[90vh]" onClick={e => e.stopPropagation()}>
            <div className="absolute -top-3 -right-3 flex gap-2 z-10">
              <a
                href={data.cert_image}
                download="费用完结证书.png"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-gray-600 shadow-lg"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              </a>
              <button
                onClick={() => setShowCert(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-gray-600 shadow-lg text-lg font-bold"
              >
                &times;
              </button>
            </div>
            <img src={data.cert_image} alt="费用完结证书" className="max-w-full max-h-[85vh] rounded-lg shadow-2xl" />
          </div>
        </div>
      )}
    </div>
  );
}
